require("./components/bootstrap");
import mixin from "./components/mixin.js";
import member from "./components/member.js";

var memberLogin = new Vue({
  el: "#app",
  mixins: [mixin, member],
  data: {
    loginData: {
      mobilePhone: "",
      password: ""
    },
    showPassword: false,
  },
  mounted: function() {
    // to not autofill mobilePhone on forgot password page again, remove the sessionStorage here (not great solution)
    sessionStorage.removeItem("autoFillForgotPasswordMobilePhoneValue")
  },
  watch: {
    "loginData.mobilePhone": function (val) {
      this.loginData.mobilePhone = this.restrictMobile(val)
    },
  },
  computed: {
    showMobile: function () {
      return this.validateMobile(this.loginData.mobilePhone)
    }
  },
  methods: {
    login: async function () {
      let error = {}
      Object.keys(this.loginData).forEach((key) => {
        if (!this.loginData[key]) {
          error[key + 'Error'] = [errorMessage[key + 'Error']]
        }
      })
      if (!this.validateMobile(this.loginData.mobilePhone)) {
        error['mobilePhoneError'] = [errorMessage['mobilePhoneError']]
      }
      if (Object.keys(error).length) {
        this.showAlert("", error)
        return false
      }
      const result = await this.memberApi("/member/login", this.loginData)
      if (result.status) {
        if (history.length) {
          window.location = document.referrer;
        } else {
          location.reload()
        }
      } else {
        if (result.code == attemptLockCode || result.code == attemptFiveTimesCode) {
          // sessionStorage is the temporary solution, could replace the method of passing mobilePhone to another page if there is a better way to do this
          sessionStorage.setItem("autoFillForgotPasswordMobilePhoneValue", this.loginData.mobilePhone);
          showAlert("", result.message, false, () => {
            window.location.href = '/member/password/forgot'
          })
        } else if (result.code == passwordExpiredCode) {
          showAlert("", result.message, false, () => {
            window.location.href = '/member/profile'
          })
        } else {
          showAlert("", result.message)
        }
      }
    }
  },
});
